import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { FieldsetModule } from 'primeng/fieldset';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';
import { ConfirmationService } from 'primeng/api';

import { DescricaoPadraoRoutingModule } from './descricao-padrao-routing.module';
import { DescricaoPadraoListarComponent } from './descricao-padrao-listar/descricao-padrao-listar.component';
import { DescricaoPadraoAdicionarComponent } from './descricao-padrao-adicionar/descricao-padrao-adicionar.component';
import { DescricaoPadraoEditarComponent } from './descricao-padrao-editar/descricao-padrao-editar.component';
import { GenericDialogComponent } from '../../shared/generic-dialog/generic-dialog.component';

@NgModule({
  declarations: [
    DescricaoPadraoListarComponent,
    DescricaoPadraoAdicionarComponent,
    DescricaoPadraoEditarComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DescricaoPadraoRoutingModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule,
    GenericDialogComponent,
    SpinnerServiceComponent,
    InputTextareaModule,
    FieldsetModule,
    ToolbarSearchComponent
  ],
  providers: [ConfirmationService]
})
export class DescricaoPadraoModule { }
